import { createCustomSlice } from './customSlice';

export const doneSlice = createCustomSlice('done');
